// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SearchPageLayout_wrapper__7IwM8"};